import React from 'react';
export function StorySection() {
  return <section id="story" className="py-24 bg-cream relative overflow-hidden" data-id="element-198">
      {/* Background Texture */}
      <div className="absolute inset-0 bg-noise opacity-30" data-id="element-199"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-200">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center" data-id="element-201">
          {/* Image Side with Quote Overlays */}
          <div className="relative order-2 lg:order-1 flex justify-center" data-id="element-202">
            <div className="relative w-full max-w-lg mx-auto" style={{
            paddingTop: '1rem',
            paddingBottom: '4rem',
            paddingLeft: '3rem',
            paddingRight: '3rem'
          }} data-id="element-203">
              {/* Top-right quote — high on right edge, well above dad's face */}
              <div className="absolute top-0 -right-2 z-20 transform translate-x-4 -translate-y-6 rotate-2 w-[185px]" data-id="element-204">
                <div className="bg-navy text-cream px-3 py-3 shadow-xl border-l-4 border-orange rounded-sm" data-id="element-205">
                  <p className="font-body text-base leading-snug italic text-cream" data-id="element-206">
                    "Dad calls it 'room temperature.' We call it 'a lecture.'"
                  </p>
                </div>
                <div className="w-0 h-0" style={{
                borderTop: '8px solid transparent',
                borderBottom: '8px solid transparent',
                borderRight: '10px solid #1a3a5c',
                position: 'absolute',
                left: '-10px',
                top: '12px'
              }} data-id="element-207"></div>
              </div>

              {/* Scrapbook photo frame */}
              <div className="relative shadow-2xl" style={{
              transform: 'rotate(-2deg)',
              filter: 'drop-shadow(4px 6px 12px rgba(44,24,16,0.45))'
            }} data-id="element-208">
                {/* Tape strips */}
                <div className="absolute -top-3 left-8 w-14 h-5 z-10 opacity-70 rounded-sm" style={{
                background: 'rgba(255,245,180,0.75)',
                transform: 'rotate(-8deg)',
                boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
              }} data-id="element-209"></div>
                <div className="absolute -top-3 right-8 w-14 h-5 z-10 opacity-70 rounded-sm" style={{
                background: 'rgba(255,245,180,0.75)',
                transform: 'rotate(6deg)',
                boxShadow: '0 1px 3px rgba(0,0,0,0.15)'
              }} data-id="element-210"></div>

                {/* Aged paper backing */}
                <div className="bg-[#f5edd8] p-3 pb-8" style={{
                border: '1px solid #d4c9a8'
              }} data-id="element-211">
                  <div className="overflow-hidden relative" style={{
                  border: '1px solid #c8bfa0'
                }} data-id="element-212">
                    <img src="https://cdn.magicpatterns.com/uploads/2xtTvEqxbZhujJk24sbGDy/State_48_HVAC.webp" alt="State 48 Family" className="w-full h-auto block" style={{
                    filter: 'sepia(0.65) contrast(1.05) brightness(0.88) saturate(0.75)'
                  }} data-id="element-213" />
                    <div className="absolute inset-0 pointer-events-none" style={{
                    background: 'radial-gradient(ellipse at center, transparent 55%, rgba(44,24,16,0.35) 100%)'
                  }} data-id="element-214"></div>
                  </div>
                  {/* Caption — inside the paper, above the bottom edge */}
                  <div className="pt-3 pb-1 text-center font-sub text-[#5a4a35] text-sm tracking-widest uppercase opacity-80" data-id="element-215">
                    The State 48 Family
                  </div>
                </div>
              </div>

              {/* Bottom-left quote — overlaps LEFT EDGE, above the caption area */}
              <div className="absolute bottom-8 -left-2 z-20 transform -translate-x-4 -rotate-2 w-[185px]" data-id="element-216">
                <div className="bg-orange text-white px-3 py-3 shadow-xl border-l-4 border-cream rounded-sm" data-id="element-217">
                  <p className="font-body text-base leading-snug italic text-white" data-id="element-218">
                    "Our bedtime stories include SEER ratings."
                  </p>
                </div>
                <div className="w-0 h-0" style={{
                borderTop: '8px solid transparent',
                borderBottom: '8px solid transparent',
                borderLeft: '10px solid #ff571e',
                position: 'absolute',
                right: '-10px',
                top: '12px'
              }} data-id="element-219"></div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2" data-id="element-220">
            <span className="text-orange font-sub text-xl uppercase tracking-widest font-bold" data-id="element-221">
              Our Journey
            </span>
            <h2 className="text-4xl md:text-5xl text-navy mt-2 mb-8 leading-tight" data-id="element-222">
              FROM HUMBLE BEGINNINGS TO{' '}
              <span className="text-orange" data-id="element-223">YOUR TRUSTED PARTNER</span>
            </h2>

            <div className="prose prose-lg text-brown/80 font-body" data-id="element-224">
              <p className="mb-6" data-id="element-225">
                State 48 Home Comfort isn't just a business; it's a testament to
                resilience and the American Dream. Our founder's journey began
                not in a boardroom, but on the streets — he went from being
                homeless to a thriving business in just a few years.
              </p>
              <p className="mb-6" data-id="element-226">
                Through hard work, unwavering faith, and a commitment to never
                giving up, he built this company from the ground up. That same
                drive fuels every job we do today. We know what it means to
                struggle, which is why we treat every customer with deep respect
                and honesty.
              </p>
              <p className="mb-8 font-bold text-navy" data-id="element-227">
                We're not just fixing ACs; we're building a legacy of service,
                integrity, and family values right here in Arizona.
              </p>
            </div>

            <div className="flex items-center gap-4" data-id="element-228">
              <div className="h-px bg-navy/20 flex-1" data-id="element-229"></div>
              <span className="font-display text-2xl text-navy" data-id="element-230">EST. 2015</span>
              <div className="h-px bg-navy/20 flex-1" data-id="element-231"></div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}